<template>
    <div class="" style="padding:.2rem 0 8rem 0">

        <div class="order-success">
            <div class="icon"></div>
            <div class="title">报名成功</div>
            <div class="desc"><p style="text-align: center"></p>
                </div>
        </div>
            <van-cell-group>
                <van-cell
                        input-align="right"
                        title="单位"
                        :value="formData.danwei"
                />
                <van-cell
                        input-align="right"
                        title="联系人 "
                        :value="formData.name"
                />

<!--                <van-cell title="视频" :value="formData.video.length+'/1'"  >-->
                    <!--<template slot="icon" >-->
                    <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
                    <!--</template>-->
<!--                </van-cell>-->

<!--                <div class="row"  >-->
<!--                    <VideoUploader :minSize="0" :fileList="formData.video" :limit="1"-->
<!--                                   @onInputClick="onVideoInputClick"-->
<!--                                   :fileName="formData.danwei+'-'+formData.name"   :name="'video'"></VideoUploader>-->
<!--                </div>-->
<!--                <div class="operate-desc-left"  >请上传一段视频</div>-->
            </van-cell-group>

        <div class="savebtn" v-if="false">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">确定保存</van-button>
        </div>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .order-success{
        text-align: center;
        margin: 20px 0 ;
    }
    .order-success .icon{
        background: url(../../../assets/images/icon-order-done.png);
        background-size: 100%;
        width: 75px;
        height: 75px;
        margin: 20px auto 20px auto;

    }
    .order-success .title{
        font-size: 18px;
        font-weight: bold;
        color: #000;
        text-align: center;
    }
    .order-success .desc{
        padding: 10px;
        text-align: left;
    }
    .order-success .desc p{
        line-height: 26px;
        font-size: 14px;
        color: #333;
        text-align: left;
    }
    .order-success img{
        width: 90%;
        /*height: 120px;*/
        margin: 10px auto;
    }
    .order-success p{
        font-size: 12px;
        color: #999;
    }

    .sai-shuo-li{
        background: #f3f3f3;
        border-radius: 10px;
        margin: 20px 10px ;
        padding: 10px;
    }
    .sai-shuo-li img{
        width: 50px;
        height: 50px;
        border-radius: 6px;
        float: left;
        margin-right: 10px;
    }
    .sai-shuo-li .c{
        width: calc(100% - 80px);
        border-right: 1px solid #00000008 ;
    }
    .sai-shuo-li .c .title{
        font-size: 14px;
        color: #000;
    }
    .sai-shuo-li .c .desc{
        font-size: 12px;
        color: #999;
    }
    .sai-shuo-li .fr{
        width: 70px;
        float: right;
    }
    .sai-shuo-li .btn{
        width: 60px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        text-align: center;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:6px;
        color: #fff;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }



</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';
    // import VideoUploader from '@/components/picker/VideoUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';


    import jquery from 'jquery';
    jquery.fn.longPress = function(fn) {
        let timeout = 0;
        const $this = this;
        console.log('jquery.fn.longPress')
        for (let i = 0; i < $this.length; i++) {
            $this[i].addEventListener('touchstart', () => {
                timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
            }, false);
            $this[i].addEventListener('touchend', () => {
                clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
            }, false);
        }
    };

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
            // VideoUploader,
        },
        data: function () {
            return {
                ltShow:false,
                ltImgSrc:'',
                ltImgName:'',
                ltActions:[{ name: '保存图片' }],
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                showSubjectPicker:false,
                showJiaolianPicker:false,
                showRoomTypePicker:false,
                showMemberPicker:false,
                formData:{
                    id:0
                },
                formData:{
                    erweiimg:[],
                    video:{
                    }
                }
            }
        },
        filters: {},
        mounted() {
            document.title = "报名成功";
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onLtSelect(item){
                let that = this;
                switch (item.name){
                    case '保存图片':
                        let name = that.ltImgSrc.split('?')[0].split('/').pop();
                        console.log(that.ltImgSrc,name);
                        appEvent({
                            name: 'downloadPic',
                            query: {
                                'filename' : name,
                                'url' : that.ltImgSrc
                            }
                        });
                        break;
                }
            },
            go(type){
                rbLink({name:'H5',query:{ url : this.row.jump_url } });
            },
            onQuestion(){
                console.log('onQuestion')
            },

            onVideoInputClick(){
                let that =this;
                console.log({
                    name:'onVideoInputClick',
                    query:{
                        'mingcheng':this.formData.danwei,
                        'subject_name':this.formData.name,
                    }
                });

                appEvent({
                    name:'onVideoInputClick',
                    query:{
                        'mingcheng':this.formData.danwei,
                        'subject_name':this.formData.name,
                    }
                });
            },
            fetch(){
                let that = this;
                that.$api.post('/api/cdakejian/successdetail', {
                    id:that.formData.id
                }, (res) => {
                    that.formData = res.data;
            }, (res) => {
                    Toast.fail(res.msg);
                })
            },

            submit(values){
                let that = this;
                console.log(that.formData)
                if(this.formData.video.length==0){
                    Toast('请上传视频');
                    return ;
                }

                that.$api.post('/api/cdakejian/videosave', that.formData, (res) => {
                    that.saveLoading = false;
                    Toast('提交成功');
                }, (res) => {

                    if (res.code == 401 || res.code == 402) {
                        if (window.isApp()) {
                            rbLink(
                                {
                                    name: "login",
                                    query: {}
                                },
                                "replace"
                            );
                            return false;
                        } else {
                            // Toast(res.msg);
                            this.loginShow = true;
                        }
                    }
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },

        }
    }
</script>



// WEBPACK FOOTER //
// DakejianApplySuccess.vue?2943b55e